import { Stack, Typography, useTheme } from "@mui/material";
import { MapPin } from "lucide-react";
import type { FC } from "react";
import { getMapsLink } from "web_myplann/Utils/getMapsLink";

type Props = {
	place: string;
};

export const ActivityAddressLink: FC<Props> = ({ place }) => {
	const { palette, iconSize, spacingTokens, activity } = useTheme();

	return (
		<Stack
			component="a"
			href={getMapsLink(place)}
			target="_blank"
			rel="noopener noreferrer"
			direction="row"
			alignItems="flex-start"
			justifyContent="flex-end"
			gap={spacingTokens.xs}
			sx={{ textDecoration: "none", "&:active": { opacity: 0.6 } }}
		>
			<MapPin
				size={iconSize.xs}
				color={palette.blue[600]}
				style={{ marginTop: activity.addressPinOffset, flexShrink: 0 }}
			/>
			<Typography variant="body2" color={palette.blue[600]} textAlign="right">
				{place}
			</Typography>
		</Stack>
	);
};
